import { FaCalendarCheck, FaUserCheck, FaClock, FaMapMarkerAlt } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaCalendarCheck />,
        title: 'Total Events',
        count: '150',
    },
    {
        id: 2,
        icon: <FaUserCheck />,
        title: 'Registered Attendees',
        count: '5000',
    },
    {
        id: 3,
        icon: <FaClock />,
        title: 'Years of Experience',
        count: '5',
    },
    {
        id: 4,
        icon: <FaMapMarkerAlt />,
        title: 'Hosted Cities',
        count: '20',
    },
];

export default counter;